"use client";

import dynamic from "next/dynamic";
import { useScroll } from "motion/react";
import { useImageParallax, UseImageParallaxProps } from "./use-image-parallax";
import { Text } from "@/components/ui/text";

const ImageParallaxPhotoFrame = dynamic(() => import("./image-parallax-photo-frame"), {
  ssr: false,
});

export type ImageParallaxProps = UseImageParallaxProps;

function ImageParallax(props: ImageParallaxProps) {
  const {
    styles,
    containerRef,
    data: { title, description, images },
    sectionName,
  } = useImageParallax(props);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 50%", "end 50%"],
  });

  return (
    <section className={styles.base()} data-section-name={sectionName} ref={containerRef}>
      <div className={styles.wrapper()}>
        <header className={styles.header()}>
          <Text tag="h2" size="displayMedium">
            {title}
          </Text>
          {description && (
            <Text tag="p" size="titleSmall" className={styles.description()}>
              {description}
            </Text>
          )}
        </header>
        {images.length > 0 && (
          <div className={styles.photos()}>
            {images.map((image, index) => (
              <ImageParallaxPhotoFrame
                key={image.id}
                image={image}
                index={index}
                scrollYProgress={scrollYProgress}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default ImageParallax;
